module.exports = __webpack_public_path__ + "static/media/food13.a5a8db6b.webp";